import { render } from "./checkboxAndRadio.vue?vue&type=template&id=34440d94"
import script from "./checkboxAndRadio.vue?vue&type=script&setup=true&lang=js"
export * from "./checkboxAndRadio.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/componentBase/AlbbPublishProduct/components/checkboxAndRadio.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "34440d94"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('34440d94', __exports__)) {
    api.reload('34440d94', __exports__)
  }
  
  module.hot.accept("./checkboxAndRadio.vue?vue&type=template&id=34440d94", () => {
    api.rerender('34440d94', render)
  })

}


export default __exports__